import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import AppBarCounter from "./app-bar-counter"
import {RANKING_SCREEN} from "../../ducks/duck-screen";

const backArrow = 'static/images/app-bar/icon_back.png';

const styles = theme => ({
	appBar: {
		backgroundColor: '#fff',
		flex: "0 0 auto",
	},
	arrow: {
		position: 'absolute',
		height: "40px",
		margin: "0 15px",
		cursor: "pointer"
	},
	title:{
		margin:'0 auto',
		"font-size": "1.25rem",
		"color": "black",
		"font-weight": "500",
		"line-height": "1.6",
		"letter-spacing": "0.0075em",
	},
	hintsCounter:{
		position: "absolute",
		right: "35px",
	}
});

function LogoQuizAppBar(props) {
	function disableShadowIfNecessary() {
		if(props.currentScreen === RANKING_SCREEN){
			return {"boxShadow": "none", "WebkitBoxShadow": "none"}
		} else {
			return {}
		}
	}

	const { classes, onClick, title, StarsImage, hintCount, currentScreen, collectedRiddlesAll } = props;
	return (
		<AppBar className={classes.appBar} style={disableShadowIfNecessary()} position="sticky">
			<Toolbar disableGutters>
				<img className={classes.arrow} src={backArrow} onClick={onClick} alt="Back arrow" id="back-arrow-button"/>
				<p className={classes.title} style={{color: "rgba(0, 0, 0, 0.87)"}}>
					{StarsImage ? (<StarsImage/>) : (title)}
					</p>
				<div className={classes.hintsCounter}>
					<AppBarCounter hintCount={hintCount} currentScreen={currentScreen} collectedRiddlesAll={collectedRiddlesAll}/>
				</div>
			</Toolbar>
		</AppBar>
	)
}

LogoQuizAppBar.propTypes = {
	classes: PropTypes.shape({
		appBar: PropTypes.string.isRequired,
		arrow: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
	}).isRequired,
	title: PropTypes.string,
	currentScreen: PropTypes.string.isRequired,
	currentLevel: PropTypes.object,
	hintCount: PropTypes.number,
	collectedRiddlesAll: PropTypes.number,
	onClick: PropTypes.func.isRequired,
	img: PropTypes.func,
	StarsImage: PropTypes.func,
};

export default withStyles(styles)(LogoQuizAppBar);